import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import AccessSettings from "../components/AccessSettings";

const ROLES = ["ADMINISTRATOR", "ADMIN", "MC", "VENDOR", "VIEWER", "TAMU"];

function Editor({ u, onClose }) {
  const isNew = !u.user_id;
  const [f, setF] = useState(isNew ? { user_id: "", name: "", role: "MC", password: "", email: "" } : { ...u });
  const [pw, setPw] = useState("");
  const save = async () => {
    try {
      if (isNew) await api.post("/users", f); else await api.put(`/users/${u.user_id}`, { name: f.name, role: f.role, status: f.status, email: f.email });
      if (!isNew && pw) await api.post(`/users/${u.user_id}/reset-password`, { new_password: pw });
      toast.success("Tersimpan / 已保存");
      onClose(true);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="modal-overlay" data-testid="user-editor-modal"><div className="modal-box small">
      <h3>{isNew ? "Tambah User / 新增用户" : `Edit ${u.user_id}`}</h3>
      {isNew && <><label>User ID *</label><input value={f.user_id} onChange={(e) => setF({ ...f, user_id: e.target.value.toUpperCase() })} data-testid="user-id-input" /></>}
      <label>Nama *</label><input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="user-name-input" />
      <label>Email</label><input value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="user-email-input" />
      <label>Role *</label><select value={f.role} onChange={(e) => setF({ ...f, role: e.target.value })} data-testid="user-role-select">{ROLES.map((r) => <option key={r}>{r}</option>)}</select>
      {!isNew && <><label>Status</label><select value={f.status} onChange={(e) => setF({ ...f, status: e.target.value })} data-testid="user-status-select"><option>ACTIVE</option><option>INACTIVE</option></select></>}
      <label>{isNew ? "Password awal * (min 8)" : "Reset Password (kosongkan jika tidak)"}</label>
      <input type="password" value={isNew ? f.password : pw} onChange={(e) => (isNew ? setF({ ...f, password: e.target.value }) : setPw(e.target.value))} data-testid="user-password-input" />
      <div className="modal-actions"><button className="btn btn-secondary" onClick={() => onClose(false)} data-testid="user-cancel-btn">Batal</button><button className="btn btn-primary" onClick={save} data-testid="user-save-btn">Simpan</button></div>
    </div></div>
  );
}

export default function Users() {
  const [rows, setRows] = useState([]);
  const [hist, setHist] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => { api.get("/users").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e))); api.get("/users/login-history").then((r) => setHist(r.data)).catch(() => {}); };
  useEffect(() => { load(); }, []);
  return (
    <div className="card wide" data-testid="users-page">
      <div className="card-head"><h3>USER & ROLE / 用户管理</h3><button className="btn-mini" onClick={() => setEdit({})} data-testid="user-add-btn">+ Tambah User</button></div>
      <div className="table-wrap"><table className="data-table" data-testid="users-table"><thead><tr><th>User ID</th><th>Nama</th><th>Role</th><th>Status</th><th>Hak Akses (server)</th><th>Login Terakhir</th><th></th></tr></thead><tbody>
        {rows.map((u) => <tr key={u.user_id}><td><b>{u.user_id}</b></td><td>{u.name}</td><td>{u.role}</td><td>{u.status}</td><td className="small">{u.permissions.join(", ")}</td><td>{String(u.last_login || "-").slice(0, 16).replace("T", " ")}</td>
          <td><button className="btn-mini" onClick={() => setEdit(u)} data-testid={`user-edit-${u.user_id}`}>Edit</button></td></tr>)}
      </tbody></table></div>
      <div className="receiving-divider">Login History / 登录历史 (200 terakhir)</div>
      <div className="table-wrap short"><table className="data-table"><thead><tr><th>Waktu</th><th>User</th><th>Status</th><th>Device</th><th>Ket</th></tr></thead><tbody>
        {hist.map((h, i) => <tr key={i}><td>{String(h.ts).slice(0, 19).replace("T", " ")}</td><td>{h.user_id}</td><td>{h.status}</td><td className="small">{String(h.device).slice(0, 60)}</td><td>{h.note}</td></tr>)}
      </tbody></table></div>
      {edit && <Editor u={edit} onClose={(ok) => { setEdit(null); if (ok) load(); }} />}
      <AccessSettings users={rows} onChanged={load} />
    </div>
  );
}
